import { FUND_TYPES } from '../../stores/profile/get-fund-type';

export const isCIT = (isProprietary, fundType) => {
  if (fundType === FUND_TYPES.collectiveTrustFund) {
    return true;
  }
  return !isProprietary &&
      (fundType === FUND_TYPES.fixedAnnuity
      || fundType === FUND_TYPES.variableAnnuity
      || fundType === FUND_TYPES.otherInvestment);
};

